const FOOTER_ID = 'sl-sticky-footer';
const STYLE_ID = 'sl-sticky-footer-styles';

export function initStickyFooter(options = {}) {
  if (typeof document === 'undefined') return;

  const { isLanding = false } = options;

  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      html, body { margin: 0; }
      body {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }
      #root {
        flex: 1 0 auto;
        display: flex;
        flex-direction: column;
      }
      #${FOOTER_ID} {
        flex-shrink: 0;
        background: var(--sl-bg, transparent);
        border-top: 1px solid var(--sl-border, rgba(255,255,255,0.08));
        color: var(--sl-gray, #a0a0b0);
        font-size: 0.8rem;
        padding: 12px;
        text-align: center;
      }
      #${FOOTER_ID} a {
        color: var(--sl-green, #a0a0b0);
        text-decoration: underline;
        margin-left: 8px;
      }
    `;
    document.head.appendChild(style);
  }

  const existing = document.getElementById(FOOTER_ID);
  if (existing) existing.remove();

  const footer = document.createElement('footer');
  footer.id = FOOTER_ID;

  const copyright = document.createTextNode(
    '© 2026 Side Loop Golf LLC. All rights reserved.'
  );
  footer.appendChild(copyright);

  if (!isLanding) {
    const link = document.createElement('a');
    link.href = 'https://sideloop.golf';
    link.textContent = 'sideloop.golf';
    footer.appendChild(link);
  }

  if (document.body) {
    document.body.appendChild(footer);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      document.body.appendChild(footer);
    }, { once: true });
  }
}
